import script from "./GridProspectoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridProspectoComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridProspectoComponent.vue?vue&type=style&index=0&id=1559dec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1559dec2"]])

export default __exports__